import O1HD from "../../../../engines/gameEngine";
import FoodMaterialConfig, { FoodMaterialEntity } from "./config/FoodMaterialConfig";
import SwingPlateManager from "./SwingPlateManager";
import {StapleFoodEntity} from "./config/StapleFoodConfig";
import swingPlateShopItem from "./swingPlateShopItem";
import {BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab} from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

/**
 * 开店
 */
@ccclass
export default class SwingPlateShop extends cc.Component {

    @property({type:cc.Prefab,displayName:"食物item 预制体"})
    goodItemPrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"桌子节点"})
    deskNode : cc.Node = null;
    @property({type:cc.Label ,displayName:"炒饭名称"})
    lbName : cc.Label = null;
    @property({type:cc.Node,displayName:"添加节点"})
    addNode : cc.Node = null;

    private swingPlateManager : SwingPlateManager;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab,displayName:"givePrefab"})
    givePrefab:cc.Prefab = null;

    itemArys:FoodMaterialEntity[] = [];

    currentPageIndex:number = 0;

    onLoad () {
        this.swingPlateManager = new SwingPlateManager( this );
        O1HD.on("SwingPlateShop.updatePage",this.updatePage,this);
        O1HD.on("SwingPlateShop.loadItems",this.loadItems,this);
        O1HD.on("cooperativeShopLoadPage",this.loadPage,this);
    }

    start(){
        //2 秒钟 进顾客
        this.scheduleOnce(()=>{
            this.swingPlateManager.enterCustomer();
        },1 );
    }

    /**
     * 返回
     */
    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 金盘子解锁
     */
    onBtnGoldPlate(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.swingPlateManager.changeGoldPlate();
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"金盘子解锁");
    }

    /**
     * 替换主食
     */
    async replaceStapleFood( stapleFoodEntity : StapleFoodEntity ){
        // 美食表现 调用 主食 划出流程 创建 主食 预制体，移动到中间对应位置
        let url : string;
        switch ( stapleFoodEntity.uniqueId ) {
            case 1:
                //米饭
                url = "prefab/good/foodRaceItem";
                break;
            case 2:
                //可乐
                url = "prefab/good/foodColaItem";
                break;
            case 3:
                //蛋糕
                url = "prefab/good/foodCakeItem";
                break;
        }
        if ( url ) {
            let prefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.setUpShopGameBundle , url );
            if ( prefab ) {
                let prefabNode = cc.instantiate( prefab );
                this.deskNode.addChild( prefabNode );
                prefabNode.setPosition(cc.v2( 600 , 390 ) );
                O1HD.emit( "FoodItem.serveFood" );
            }
        }
    }

    //加载页面
    loadPage(...args){
        let isVideo = args[0];
        if(isVideo){
            let node:cc.Node = cc.instantiate(this.givePrefab);
            node.setParent( O1HD.Canvas() );
        }else{
            this.loadItems();
        }
    }

    loadItems(){
        let cAry:FoodMaterialEntity[] = [];
        let config = FoodMaterialConfig();
        for(let c of config){
            let cBackId = c.goodsId;
            let cBack = NormalGameManager._instance.getGameData().backpack[cBackId];
            let cType = c.type;
            if((cType!=2 && cBack) || (c.videoFlag && cType!=2)){
                cAry.push(c);
            }
        }
        cAry.sort((a:FoodMaterialEntity,b:FoodMaterialEntity)=>{
            let aNum:number = 0;
            let bNum:number = 0;
            if(a.videoFlag){
                aNum = 1
            }
            if(b.videoFlag){
                bNum = 1;
            }
            return bNum - aNum;
        });

        this.itemArys = cAry.concat();
        this.updatePage();
    }

    //更新页面
    updatePage(pageIndex:number = this.currentPageIndex){
        this.itemContent.children.forEach((n:cc.Node,index:number)=>{
            let itemIndex = pageIndex * 8 + index;
            let cConfig = this.itemArys[itemIndex];
            let ns = n.getComponent(swingPlateShopItem);
            ns.bindData(cConfig);
            ns.updateItem();
        });
    }

    onBtnLeft(){
        if(this.currentPageIndex > 0){
            this.currentPageIndex -= 1;
            this.updatePage();
        }
    }

    onBtnRight(){
        let maxPage:number = Math.ceil(this.itemArys.length / 8);
        if(this.currentPageIndex < maxPage){
            this.currentPageIndex ++;
            this.updatePage();
        }
    }

}
